module.exports = __webpack_public_path__ + "static/teleco_16-b3d1278c136ab4d8e8ef50755fa3f1a1.jpg";